import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import OneXButton from "../OneX/OneXButton";
import EnsightenAnalytics from "../Utility/EnsightenAnalytics";
import Flex from "../LAUI/Flex";
import useMedia from "use-media";
import { useRecoilValue } from "recoil";
import { firstNameState, quotesState, successfulMatchState } from "../AppData/Recoil";
import OneXSpecs from "../OneX/OneXSpecs";

const SavedQuoteMobileView = ({ quoteLOB, quoteProductLine, lastEdited, retrieveUrl, renderHorizontalRule }) => {
  return (
    <Flex flexDirection={"column"}>
      {renderHorizontalRule ? <hr align="center" /> : null}
      <div style={{ marginTop: "24px", marginLeft: "23px" }}>
        <div>{quoteLOB === "A" ? "Auto Quote" : quoteProductLine}</div>
      </div>
      <div
        style={{
          marginTop: "24px",
          marginLeft: "23px",
          marginRight: "24px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ color: "#767676" }}>{"Last Edited"}</div>
        <div>{lastEdited}</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          marginLeft: "23px",
          marginTop: "32px",
          marginBotttom: "24px",
        }}
        className={"-oneX-body--secondary"}
      >
        <OneXButton
          id={"retrieveButton"}
          paddingBottom="0px"
          type="primary"
          disableTabbing
          clickHandler={() => {
            window.location = retrieveUrl;
          }}
        >
          {"Select"}
        </OneXButton>
      </div>
    </Flex>
  );
};

const SavedQuotesDesktop = ({ quoteLOB, quoteProductLine, lastEdited, retrieveUrl, renderHorizontalRule }) => {
  return (
    <>
      {renderHorizontalRule ? <hr align="center" /> : null}
      <div
        style={{
          width: "100%",

          display: "grid",
          gridTemplateColumns: "33% 16% 51%",
          gridTemplateRows: "auto",
          alignItems: "center",
          paddingLeft: "40px",
          paddingTop: "32px",
          paddingBottom: "32px",
        }}
      >
        <div>
          <div>{quoteLOB === "A" ? "Auto Quote" : quoteProductLine}</div>
        </div>
        <div className={"-oneX-body--secondary"}>{lastEdited}</div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          className={"-oneX-body--secondary"}
        >
          <OneXButton
            paddingBottom="0px"
            type="primary"
            id={"retrieveButton"}
            clickHandler={() => {
              window.location = retrieveUrl;
            }}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                window.location = retrieveUrl;
              }
            }}
          >
            {"Select"}
          </OneXButton>
        </div>
      </div>
    </>
  );
};

const SavedQuotesList = ({ id }) => {
  const [init, setInit] = useState(false);

  const firstName = useRecoilValue(firstNameState);

  const quotes = useRecoilValue(quotesState);
  const successfulMatch = useRecoilValue(successfulMatchState);

  const desktopView = useMedia({ minWidth: "767px" });

  const isMobile = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.MOBILE);
  const isTablet = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.TABLET);
  const isDesktop = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.DESKTOP);

  useEffect(() => {
    if (!init) {
      window.scrollTo(0, 0);
      EnsightenAnalytics.pushScreenChangeToAnalytics("saved-quotes-list");
      setInit(true);
    }
    // eslint-disable-next-line
  }, [init]);

  const renderedQuotes = [];

  if (quotes) {
    quotes.map((item, id) => {
      if (desktopView) {
        renderedQuotes.push(
          <SavedQuotesDesktop
            quoteLOB={item.quoteLob}
            quoteProductLine={item.quoteProductLongName}
            lastEdited={item.editedDateUI}
            retrieveUrl={item.viewUrl}
            key={`${item.quoteLob}-${id}`}
          />
        );
      } else {
        renderedQuotes.push(
          <SavedQuoteMobileView
            quoteLOB={item.quoteLob}
            quoteProductLine={item.quoteProductLongName}
            lastEdited={item.editedDateUI}
            retrieveUrl={item.viewUrl}
            key={`${item.quoteLob}-${id}`}
          />
        );
      }
      return "added";
    });
  }

  return init && successfulMatch ? (
    <div
      id={id}
      className={"-oneX-col-lg-12 -oneX-col-md-8 -oneX-col-sm-10"}
      style={{
        marginBottom: "224px",
      }}
    >
      <h1 id={`${id}-header`} style={{ marginTop: isDesktop ? "56px" : isTablet ? "48px" : isMobile ? "40px" : "40px" }}>
        {firstName.value === null ? `Hello,` : `Hi ${firstName.value.substring(0, 1).toUpperCase() + firstName.value.substring(1).toLowerCase()},`}
      </h1>
      <div className={"-oneX-body--intro"} style={{ marginBottom: "27px" }}>
        {"Select a saved quote to pick up where you left off."}
      </div>
      <div
        className={"-oneX-eyebrow"}
        style={{
          backgroundColor: "#F7F0E4",
          width: "100%",
          display: "grid",
          gridTemplateColumns: "33% 67%",
          gridTemplateRows: "auto",
          alignItems: "center",
          paddingLeft: "40px",
          paddingTop: "12px",
          paddingBottom: "12px",
        }}
      >
        <div className={"-oneX-font--bold"}>Saved quote</div>
        {desktopView ? <div>Last edited</div> : null}
      </div>
      {renderedQuotes.length > 0 ? renderedQuotes : null}
    </div>
  ) : null;
};

export default SavedQuotesList;

SavedQuotesList.propTypes = {
  header: PropTypes.string,
  id: PropTypes.string.isRequired,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  primaryRoute: PropTypes.string,
  secondaryRoute: PropTypes.string,
  children: PropTypes.element,
};
